<div class="qr-container">
  <div #qrcode></div>
</div>
